'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.props = props;
function attrEscape(str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
}
function escape(str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
}

const HEAD = exports.HEAD = Symbol('head');

function props() {
  for (var _len = arguments.length, attrs = Array(_len), _key = 0; _key < _len; _key++) {
    attrs[_key] = arguments[_key];
  }

  return function (clazz) {
    const target = clazz.prototype || clazz;

    for (const name of attrs) {
      Object.defineProperty(target, name, {
        get: function get() {
          if (this.attributes) {
            return this.attributes[name];
          }
        },
        set: function set(value) {
          if (this.attributes === undefined) {
            this.attributes = {};
          }
          this.attributes[name] = value;
        },

        configurable: true,
        enumerable: true
      });
    }

    return clazz;
  };
}

let Node = exports.Node = class Node {
  constructor() {
    let attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    let xmlName = arguments[2];

    for (const key of Object.keys(attributes)) {
      this[key] = attributes[key];
    }
    this.children = children;
    this._xmlName = xmlName || this.constructor.name.substring(1);
  }
  render() {
    function walk(tree) {
      const name = tree._xmlName;
      const attributes = tree.attributes,
            children = tree.children;

      const tokens = [];

      if (tree[HEAD]) {
        tokens.push(tree[HEAD]);
      }
      tokens.push(`<${ name }`);

      for (const key of Object.keys(attributes || {})) {
        let v = attributes[key];
        if (v === undefined) continue;
        if (typeof v === 'string') {
          v = attrEscape(v);
        }
        tokens.push(` ${ key }="${ v }"`);
      }

      if (!children.length) {
        tokens.push('/>');
        return tokens;
      }
      tokens.push('>');
      for (const child of children) {
        if (child instanceof Node) {
          tokens.push(child.render());
        } else if (typeof child === 'string') {
          tokens.push(escape(child));
        } else {
          tokens.push(child.toString());
        }
      }
      tokens.push(`</${ name }>`);
      return tokens;
    }
    return walk(this).join('');
  }
};